// extracted by mini-css-extract-plugin
module.exports = {"side-menu":"style_side-menu__3VM80","menu-text":"style_menu-text__39zNJ"};